import { css } from 'styled-components';
import { map } from '../../breakpoint';
import { m, mx, my, mt, mb, ml, mr, mbs, mie, mbe, mis, mbl, mi } from '../../spacing';
// eslint-disable-line  @typescript-eslint/no-explicit-any
export const margins = ()=>css`
  ${({ margin })=>map(margin, (val)=>val !== undefined && css`
          ${m(val)};
        `)};

  ${({ marginHorizontal } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginHorizontal, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${mx(val)};
        `)};

  ${({ marginVertical } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginVertical, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${my(val)};
        `)};

  ${({ marginTop } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginTop, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${mt(val)};
        `)};

  ${({ marginBottom } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginBottom, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${mb(val)};
        `)};

  ${({ marginLeft } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginLeft, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${ml(val)};
        `)};

  ${({ marginRight } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginRight, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${mr(val)};
        `)};

  ${({ marginBlockStart } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginBlockStart, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${mbs(val)};
        `)};

  ${({ marginInlineEnd } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginInlineEnd, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${mie(val)};
        `)};

  ${({ marginBlockEnd } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginBlockEnd, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${mbe(val)};
        `)};

  ${({ marginInlineStart } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginInlineStart, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${mis(val)};
        `)};

  ${({ marginBlock } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginBlock, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${mbl(val)};
        `)};

  ${({ marginInline } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(marginInline, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          ${mi(val)};
        `)};
`;

//# sourceMappingURL=margin.js.map